import { useContext } from 'react';
import { EditMarketContext } from './EditMarket.context.tsx';

export const useEditMarket = () => {
  const context = useContext(EditMarketContext);

  if (!context) {
    throw new Error('useEditMarket() must be used within EditMarketProvider');
  }

  return context;
};
